import React from 'react';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import TrustIndicators from './components/TrustIndicators';

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Login - Clean360 | Professional Cleaning Services</title>
        <meta name="description" content="Sign in to your Clean360 account to manage bookings, track services, and access your cleaning service dashboard." />
        <meta name="keywords" content="Clean360 login, cleaning services account, customer portal, admin dashboard" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Main Content */}
        <div className="flex min-h-screen">
          {/* Left Side - Login Form */}
          <div className="flex-1 flex items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
            <div className="w-full max-w-md space-y-8">
              <LoginHeader />
              <LoginForm />
            </div>
          </div>

          {/* Right Side - Trust Indicators (Hidden on mobile) */}
          <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-center bg-muted/30 px-8 py-12">
            <div className="w-full max-w-md">
              <TrustIndicators />
            </div>
          </div>
        </div>

        {/* Mobile Trust Indicators */}
        <div className="lg:hidden px-4 pb-12">
          <div className="max-w-md mx-auto">
            <TrustIndicators />
          </div>
        </div>

        {/* Background Pattern */}
        <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-32 w-80 h-80 bg-primary/5 rounded-full blur-3xl" />
          <div className="absolute -bottom-40 -left-32 w-80 h-80 bg-accent/5 rounded-full blur-3xl" />
        </div>
      </div>
    </>
  );
};

export default LoginPage;